import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { DeleteDialog } from '../dialogs/delete.component';
import { HospitalDetailComponent } from './detail/hospital-detail.component';
import { PaginationResult } from 'src/app/models/common.response';
import { Subject } from 'rxjs';
import { HospitalService } from './hospital.service';
import { IHospitalInfo } from './ihospital-info';
import { PAGE_SIZE_OPTIONS } from 'src/app/common/constant/constants.type';


const employees = [
  {
    id: 1,
    Name: 'Johnathan Deo',
    Position: 'Seo Expert',
    Email: 'r@gmail.com',
    Mobile: 9786838,
    DateOfJoining: new Date('01-2-2020'),
    Salary: 12000,
    Projects: 10,
    imagePath: 'assets/images/profile/user-2.jpg',
  },
  {
    id: 2,
    Name: 'Mark Zukerburg',
    Position: 'Web Developer',
    Email: 'mark@gmail.com',
    Mobile: 8786838,
    DateOfJoining: new Date('04-2-2020'),
    Salary: 12000,
    Projects: 10,
    imagePath: 'assets/images/profile/user-3.jpg',
  },
  {
    id: 3,
    Name: 'Sam smith',
    Position: 'Web Designer',
    Email: 'sam@gmail.com',
    Mobile: 7788838,
    DateOfJoining: new Date('02-2-2020'),
    Salary: 12000,
    Projects: 10,
    imagePath: 'assets/images/profile/user-4.jpg',
  },
  {
    id: 4,
    Name: 'John Deo',
    Position: 'Tester',
    Email: 'john@gmail.com',
    Mobile: 8786838,
    DateOfJoining: new Date('03-2-2020'),
    Salary: 12000,
    Projects: 11,
    imagePath: 'assets/images/profile/user-5.jpg',
  },
  {
    id: 5,
    Name: 'Genilia',
    Position: 'Actor',
    Email: 'genilia@gmail.com',
    Mobile: 8786838,
    DateOfJoining: new Date('05-2-2020'),
    Salary: 12000,
    Projects: 19,
    imagePath: 'assets/images/profile/user-6.jpg',
  },
  {
    id: 6,
    Name: 'Jack Sparrow',
    Position: 'Content Writer',
    Email: 'jac@gmail.com',
    Mobile: 8786838,
    DateOfJoining: new Date('05-21-2020'),
    Salary: 12000,
    Projects: 5,
    imagePath: 'assets/images/profile/user-7.jpg',
  },
  {
    id: 7,
    Name: 'Tom Cruise',
    Position: 'Actor',
    Email: 'tom@gmail.com',
    Mobile: 8786838,
    DateOfJoining: new Date('02-15-2019'),
    Salary: 12000,
    Projects: 9,
    imagePath: 'assets/images/profile/user-3.jpg',
  },
  {
    id: 8,
    Name: 'Hary Porter',
    Position: 'Actor',
    Email: 'hary@gmail.com',
    Mobile: 8786838,
    DateOfJoining: new Date('07-3-2019'),
    Salary: 12000,
    Projects: 7,
    imagePath: 'assets/images/profile/user-6.jpg',
  },
  {
    id: 9,
    Name: 'Kristen Ronaldo',
    Position: 'Player',
    Email: 'kristen@gmail.com',
    Mobile: 8786838,
    DateOfJoining: new Date('01-15-2019'),
    Salary: 12000,
    Projects: 1,
    imagePath: 'assets/images/profile/user-5.jpg',
  },
];

@Component({
  selector: 'app-hospital',
  standalone: true,
  imports: [
    MaterialModule,
    TablerIconsModule,
  ],
  providers: [DatePipe],
  templateUrl: './hospital.component.html',
  styleUrl: './hospital.component.scss'
})
export class HospitalComponent implements OnInit {
  dataSource = new MatTableDataSource<IHospitalInfo>();
  displayedColumns: string[] = [
    '#',
    'name',
    'Doctors',
    'OPDs',
    'Patients',
    'registrationNumber',
    'panNumber',
    'mobile',
    'phoneno',
    // 'address',
    'city',
    // 'postalCode',
    'state',
    'country',
    'action',
  ];
  pagination: PaginationResult;
  Hospitalcount: number = 0;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  hospitaldata: IHospitalInfo;
  pageSizeOptions = PAGE_SIZE_OPTIONS;


  constructor(
    private dialog: MatDialog,
    private _hospitalService: HospitalService
  ) { }

  ngOnInit(): void {
    this.addHospital();
  }

  addHospital() {
    this.dialog.open(HospitalDetailComponent, {
      height: '80vh',
      minWidth: '70vw',
    }).afterClosed().subscribe(() => {

    });
  }

  deleteDialog(id: number) {

    const confirmation = this.dialog.open(DeleteDialog, {
      width: 'auto',
      enterAnimationDuration: '300ms',
      exitAnimationDuration: '300ms',
      data: { message: "Are you sure you want to delete this Hospital?" }
    })
    confirmation.afterClosed().subscribe((result) => {

    });
  }

  editDialog(data: IHospitalInfo) {
    this.dialog.open(HospitalDetailComponent, { //chage componenet 
      autoFocus: false,
      data: {
        hospital: data
      }
    }).afterClosed().subscribe((result) => {

    });
  }

}
